module.exports = __webpack_public_path__ + "static/media/navigate-left.81e70505.svg";